import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { Field } from 'formik';
import Actions from 'actions';
import Selectors from 'selectors';
import {
  AvatarInput,
  MultiSelectField,
  SelectInput,
  TextInput,
} from 'components/Form';
import { arrayToOptions, YEAR_OPTIONS } from 'utils/helper';
import isEmpty from 'lodash/isEmpty';

const AboutYouStep = ({ country, fieldKeys, isLoading, languagesOptions }) => {
  const dispatch = useDispatch();
  const cities = useSelector(Selectors.citiesOfCountry);
  const memberTypes = useSelector(Selectors.memberTypesList);

  useEffect(() => {
    dispatch(Actions.fetchMemberTypes());
    if (country) dispatch(Actions.fetchCitiesOfCountry(country));
  }, [country, dispatch]);

  const memberTypeOptions = memberTypes.map(({ id, name }) => ({
    label: name,
    value: id,
  }));

  const show = (key) => fieldKeys.includes(key);

  return (
    <div className="flex flex-col lg:flex-row lg:items-start">
      {show('profile_photo') && (
        <div className="lg:mr-10 flex-shrink-0">
          <AvatarInput name="avatar" />
          <p className="text-xs text-dusty text-center max-w-60 mx-auto -mt-5 mb-8 lg:mb-0">
            A clear photo helps members recognise you.
          </p>
        </div>
      )}
      <div className="flex-1">
        {show('city') && (
          <Field
            name="city"
            component={SelectInput}
            isDisabled={isEmpty(cities)}
            isLoading={isLoading}
            options={arrayToOptions(cities)}
            placeholder="City"
          />
        )}
        {show('industry_since') && (
          <Field
            name="industry_since"
            component={SelectInput}
            listHeight={150}
            options={YEAR_OPTIONS}
            placeholder="Started working in the music industry"
          />
        )}
        {show('member_types') && (
          <MultiSelectField
            name="member_types"
            label="Member types (up to 3)"
            max={3}
            options={memberTypeOptions}
            placeholder="Select member type(s)"
          />
        )}
        {show('biography') && (
          <Field
            name="biography"
            component={TextInput}
            placeholder="Tell us about your background and what you do"
            label="Short biography"
            type="textarea"
            showRemaining
            maxLength={500}
          />
        )}
        {show('languages') && (
          <div className="mt-3">
            <Field
              name="languages"
              component={SelectInput}
              isLoading={isLoading}
              isMulti
              placeholder="Languages spoken"
              options={arrayToOptions(languagesOptions)}
              creatable
            />
          </div>
        )}
      </div>
    </div>
  );
};

AboutYouStep.propTypes = {
  country: PropTypes.string,
  fieldKeys: PropTypes.array.isRequired,
  isLoading: PropTypes.bool.isRequired,
  languagesOptions: PropTypes.array.isRequired,
};

AboutYouStep.defaultProps = {
  country: null,
};

export default AboutYouStep;
